export default IconTrianglePlus2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-triangle-plus-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18.69 12.027l-5.054 -8.437a1.914 1.914 0 0 0 -3.274 0l-8.105 13.535a1.914 1.914 0 0 0 1.636 2.871h8.107" />
  <path d="M16 19h6" />
  <path d="M19 16v6" />
</svg>`;